export default "__VITE_ASSET__CVVioEZs__"